<bui-group>
	<bui-field>
		<bui-label required> {{ 'label.pflichtfeld' | msgKey }}</bui-label>
	</bui-field>
</bui-group>
